"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovablePowerplant = void 0;
const zod_1 = require("zod");
const enums_1 = require("./enums");
const atomics_1 = require("../atomics");
const utils_1 = require("../utils");
const descriptions_1 = require("./subschemas/descriptions");
const location_1 = require("./subschemas/location");
const propertyDetails_1 = require("./subschemas/propertyDetails");
const documents_1 = require("./subschemas/documents");
const images_1 = require("./subschemas/images");
const revenue_pool_1 = require("../revenue-pool/revenue-pool");
exports.ApprovablePowerplant = zod_1.z.object({
    id: zod_1.z.string(),
    partnerId: zod_1.z.string(),
    updatedAt: zod_1.z.coerce.date(),
    type: zod_1.z.enum(utils_1.availableAssetTypes),
    descriptions: descriptions_1.DescriptionValidationSchema.pick({
        title: true,
        powerplantPictureTitle: true,
        powerplantPictureDetails: true,
        moduleType: true,
        nominalPowerPerModule: true,
        propertyDetails: true,
        locationDetails: true,
        districtDetails: true,
        propertyQuote: true,
        cityDetails: true,
        rentalDetails: true,
        investmentDetails: true,
        securityDetails: true,
    })
        .extend({
        nomenclature: descriptions_1.NomenclatureSchema.pick({
            rentalIncomeTitle: true,
            rentalIncome: true,
            managementFee: true,
            liquidityReserve: true,
            total: true,
            expectedYieldDisclaimer: true,
        })
            .extend({
            documents: zod_1.z.object({
                rentalAgreement: atomics_1.arrayOfLangValues,
                expertProtocol: atomics_1.arrayOfLangValues,
                landRegister: atomics_1.arrayOfLangValues,
                energyCertificate: atomics_1.arrayOfLangValues,
                utilityReport: atomics_1.arrayOfLangValues,
            }),
        })
            .partial(),
    })
        .partial(),
    location: location_1.LocationValidationSchema.pick({
        address: true,
        postalCode: true,
        city: true,
        countryCode: true,
        coordinates: true,
    }),
    propertyDetails: propertyDetails_1.PropertyDetailsValidationSchema.pick({
        constructionStatus: true,
        powerOutput: true,
        powerOutputPerAnno: true,
        constructionType: true,
        commissioningDate: true,
        lifespan: true,
        propertySecurity: true,
        powerplantType: true,
        highlights: true,
        storage: true,
        storageSize: true,
    }),
    // TODO: pick type
    investmentDetails: zod_1.z
        .object({
        stage: zod_1.z.enum(['preparing']),
        ISIN: zod_1.z.string().min(1).max(12),
        issueEndDate: zod_1.z.coerce.date(),
        issueFundingFloor: zod_1.z.number(),
        issueStartDate: zod_1.z.coerce.date(),
        maturity: utils_1.booleanField,
        maturityDate: zod_1.z.coerce.date(),
        minSubscriptionAmount: zod_1.z.number().max(100),
        securityType: zod_1.z.nativeEnum(enums_1.TSecurityType),
        sharePrice: zod_1.z.number().min(1),
        spv: utils_1.mongoDBObjectIdSchema,
        terminationRight: zod_1.z.nativeEnum(enums_1.TTerminationRight),
        terminationRightFrequency: zod_1.z.string(),
        totalBricks: zod_1.z.number().min(1),
        forumActive: zod_1.z.boolean().optional(),
    })
        .refine((data) => {
        if (data.terminationRight !== enums_1.TTerminationRight.no) {
            if (data.terminationRightFrequency === null || data.terminationRightFrequency === undefined) {
                return false;
            }
        }
        return true;
    }, {
        message: 'When Termination right is not "no" then Termination right frequency must be provided',
        path: ['terminationRightFrequency'],
    }),
    // TODO: pick type
    rentalDetails: zod_1.z.object({
        payoutInterval: zod_1.z.nativeEnum(enums_1.TPayoutInterval),
        rentalReturn: zod_1.z.number(),
        rentalIncome: zod_1.z.number(),
        liquidityReserve: zod_1.z.number(),
        rentalSurplus: zod_1.z.number(),
        plannedFirstRentalIncomeDate: zod_1.z.coerce.date().optional(),
        monthlyDistributionDate: zod_1.z.number(),
        additionalManagementCosts: zod_1.z
            .array(zod_1.z.object({
            name: zod_1.z.string(),
            amount: zod_1.z.number(),
        }))
            .optional(),
        revenuePool: zod_1.z.union([zod_1.z.string(), revenue_pool_1.RevenuePoolSchema]).optional(),
    }),
    documents: documents_1.DocumentsValidationSchema.pick({
        investmentBasicInformation: true,
        investmentInformation: true,
        investmentConditions: true,
        rentalAgreement: true,
        additionalDocuments: true,
    }),
    images: images_1.ImagesValidationSchema.pick({
        powerplant: true,
        propertyPhotos: true,
        locationPhotos: true,
    }),
});
//# sourceMappingURL=powerplantAsset.js.map